import React, { useEffect } from "react";
import CalendarAssorts from "../Assorts";
import useCalendarSale from "../hooks/useCalendarSale";
import "./style.scss";
import "./oneExercise.scss";
import { Exercise } from "../../../models/Exercise";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
interface IProps {
  exercise: Exercise;
  refreshCapacityAfterAddTicket: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  alertCalendar: string;
}

const CalendarOneExercise: React.FC<IProps> = ({ exercise, refreshCapacityAfterAddTicket, joinToExerciseByPass, alertCalendar }: IProps) => {
  const { t } = useTranslation();
  const { getTicketsByExercise, tickets, ticketAccess, ticketLimit, getDetailsAboutExercise, exerciseDetails } = useCalendarSale();

  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup.objectId, exercise)
    getDetailsAboutExercise(exercise.exerciseGroup.objectId)
  }, []);


  const matches = useMediaQuery("(min-width: 1100px)");

  return (
    <React.Fragment>
      {matches ? (
        <div className="calendar-modal-one-exercise box shadow border">
          <CalendarAssorts alertCalendar={alertCalendar} exerciseDetails={exerciseDetails} joinToExerciseByPass={joinToExerciseByPass} tickets={tickets} ticketAccess={ticketAccess} ticketLimit={ticketLimit} refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket} />
        </div>
      ) : (
        <div className="">
          <div className="calendar-modal-steps">
            <div className="step flex-start-center">
              <b>2</b>
              <span>{t("wybierz_rodzaj_i_ilosc_biletow")}</span>
            </div>
          </div>

          <CalendarAssorts alertCalendar={alertCalendar} exerciseDetails={exerciseDetails} joinToExerciseByPass={joinToExerciseByPass} tickets={tickets} ticketAccess={ticketAccess} ticketLimit={ticketLimit} refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}/>
        </div>
      )}
    </React.Fragment>
  );
};

export default CalendarOneExercise;
